export default "__VITE_ASSET__CYcaz2Qz__"